import React from 'react';

const ScrollSpyContext = React.createContext<{
  activeSection: string;
  setActiveSection: (e: string) => void;
}>({
  activeSection: '',
  setActiveSection: (s) => {},
});

const ScrollSpyContextProvider = (props) => {
  const [activeSection, setActiveSection] = React.useState<string>('');

  return (
    <ScrollSpyContext.Provider
      value={{
        activeSection,
        setActiveSection,
      }}
      {...props}
    />
  );
};

function useScrollSpyContext() {
  const ctx = React.useContext(ScrollSpyContext);
  return ctx;
}

export { ScrollSpyContext, ScrollSpyContextProvider, useScrollSpyContext };
